/**
 * Generates a workspace slug from a workspace name.
 *
 * The slug is a kebab-case version of the name with a 6-character
 * random suffix (characters A–L) appended to ensure uniqueness.
 *
 * Example: "My Great Workspace" → "my-great-workspace-ghfalk"
 */

const SUFFIX_CHARS = "abcdefghijkl";
const SUFFIX_LENGTH = 6;

function generateRandomSuffix(): string {
  let suffix = "";
  for (let i = 0; i < SUFFIX_LENGTH; i++) {
    suffix += SUFFIX_CHARS[Math.floor(Math.random() * SUFFIX_CHARS.length)];
  }
  return suffix;
}

function toKebabCase(name: string): string {
  return name
    .trim()
    .toLowerCase()
    .replace(/[^a-z0-9\s-]/g, "") // remove non-alphanumeric characters (except spaces and hyphens)
    .replace(/[\s_]+/g, "-") // replace spaces and underscores with hyphens
    .replace(/-+/g, "-") // collapse multiple hyphens
    .replace(/^-|-$/g, ""); // trim leading/trailing hyphens
}

export function generateWorkspaceSlug(workspaceName: string): string {
  const kebab = toKebabCase(workspaceName);
  const suffix = generateRandomSuffix();

  if (!kebab) {
    return suffix;
  }

  return `${kebab}-${suffix}`;
}
